import React, { useEffect, useState } from "react";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import {
  matchPath,
  NavLink as RouterLink,
  useLocation,
} from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

export default function NavSectionItem({ data }) {
  const { pathname } = useLocation();
  const [openDropdown, setOpenDropdown] = useState(false);

  const handleClickDropdown = () => {
    setOpenDropdown((prev) => !prev);
  };

  const match = ({ path, matches }) => {
    if (matches) {
      return matches.some((match_path) =>
        matchPath({ path: match_path, end: false }, pathname)
      );
    }
    return path ? !!matchPath({ path, end: false }, pathname) : false;
  };

  useEffect(() => {
    data.children?.forEach((child) => {
      if (
        (child.matches &&
          child.matches.some((match) => pathname.includes(match))) ||
        pathname.includes(child.route)
      ) {
        setOpenDropdown(true);
      }
    });
  }, [pathname, data.children]);

  const activeGradient =
    "linear-gradient(to right, #181921, #181921, #181921, #181921)";
  const activeTextColor = "#fff";
  const inactiveIconColor = "#181921";

  const isParentActive = match({ path: data.route, matches: data.matches });
  const ParentComponent = data.children ? "div" : RouterLink;

  return (
    <>
      {data.children && <Divider sx={{ my: 1 }} />}

      <ListItemButton
        component={ParentComponent}
        to={data.children ? undefined : data.route}
        onClick={data.children ? handleClickDropdown : undefined}
        style={{
          background: isParentActive ? activeGradient : "none",
          color: isParentActive ? activeTextColor : "inherit",
          borderRadius: "4px",
        }}
        className="menus-list"
        onMouseEnter={(e) => {
          e.currentTarget.style.background = activeGradient;
          e.currentTarget.style.color = activeTextColor;

          const icon = e.currentTarget.querySelector(".sidebar-icons");
          if (icon) icon.style.color = activeTextColor;

          const expand = e.currentTarget.querySelector(".expand-icon");
          if (expand) expand.style.color = activeTextColor;

          const text = e.currentTarget.querySelector(
            ".MuiListItemText-primary"
          );
          if (text) text.style.color = activeTextColor;
        }}
        onMouseLeave={(e) => {
          if (!isParentActive) {
            e.currentTarget.style.background = "none";
            e.currentTarget.style.color = "inherit";

            const icon = e.currentTarget.querySelector(".sidebar-icons");
            if (icon) icon.style.color = inactiveIconColor;

            const expand = e.currentTarget.querySelector(".expand-icon");
            if (expand) expand.style.color = inactiveIconColor;

            const text = e.currentTarget.querySelector(
              ".MuiListItemText-primary"
            );
            if (text) text.style.color = "inherit";
          }
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          my: 1,
        }}
      >
        <div
          className="sidebar-icons"
          style={{
            color: isParentActive ? activeTextColor : inactiveIconColor,
          }}
        >
          {data.icon}
        </div>
        <ListItemText
          primary={data.title}
          primaryTypographyProps={{
            style: { color: isParentActive ? activeTextColor : "inherit" },
          }}
        />
        {data.children &&
          (openDropdown ? (
            <ExpandLess
              className="expand-icon"
              style={{
                color: isParentActive ? activeTextColor : inactiveIconColor,
              }}
            />
          ) : (
            <ExpandMore
              className="expand-icon"
              style={{
                color: isParentActive ? activeTextColor : inactiveIconColor,
              }}
            />
          ))}
      </ListItemButton>

      {data.children && (
        <Collapse in={openDropdown} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {data.children.map((child, idx) => {
              const isActive = match({
                path: child.route,
                matches: child.matches,
              });

              return (
                <React.Fragment key={idx}>
                  <ListItemButton
                    component={RouterLink}
                    to={child.route}
                    style={{
                      background: isActive ? activeGradient : "none",
                      color: isActive ? activeTextColor : "inherit",
                    }}
                    className="menus-list child-menus-list"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = activeGradient;
                      e.currentTarget.style.color = activeTextColor;

                      const icon =
                        e.currentTarget.querySelector(".sidebar-icons");
                      if (icon) icon.style.color = activeTextColor;

                      const text = e.currentTarget.querySelector(
                        ".MuiListItemText-primary"
                      );
                      if (text) text.style.color = activeTextColor;
                    }}
                    onMouseLeave={(e) => {
                      if (!isActive) {
                        e.currentTarget.style.background = "none";
                        e.currentTarget.style.color = "inherit";

                        const icon =
                          e.currentTarget.querySelector(".sidebar-icons");
                        if (icon) icon.style.color = inactiveIconColor;

                        const text = e.currentTarget.querySelector(
                          ".MuiListItemText-primary"
                        );
                        if (text) text.style.color = "inherit";
                      }
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      pl: 4,
                    }}
                  >
                    <div
                      className="sidebar-icons"
                      style={{
                        color: isActive ? activeTextColor : inactiveIconColor,
                      }}
                    >
                      {child.icon}
                    </div>
                    <ListItemText
                      primary={child.title}
                      primaryTypographyProps={{
                        style: {
                          color: isActive ? activeTextColor : "inherit",
                        },
                      }}
                    />
                  </ListItemButton>
                  {idx === data.children.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
          </List>
        </Collapse>
      )}
    </>
  );
}
